import { render } from "./TechnologySection.vue?vue&type=template&id=3c0b09aa"
import script from "./TechnologySection.vue?vue&type=script&lang=js"
export * from "./TechnologySection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__